module.exports = __webpack_public_path__ + "img/request-tracker-admin2.8f011a2f.png";